import { ChevronDownIcon, XIcon } from "lucide-react";
import React from "react";
import {
  ComboBoxStateContext,
  ComboBox as RACComboBox,
  type ComboBoxProps as RACComboBoxProps,
} from "react-aria-components";

import { Button, type ButtonProps } from "@/components/ui/button";
import {
  FieldGroup,
  type InputProps,
  UnstyledInput,
} from "@/components/ui/field";
import { SelectItem, SelectList, SelectSection } from "@/components/ui/select";

export function ComboBox(props: RACComboBoxProps<object>) {
  return (
    <RACComboBox {...props} className="group flex flex-col gap-1 min-w-0" />
  );
}

export function ComboBoxInput({
  ref,
  hideClear,
  ...props
}: InputProps & { hideClear?: boolean }) {
  return (
    <FieldGroup>
      <UnstyledInput ref={ref} {...props} />
      {!hideClear && <ComboBoxClearButton />}
      <ComboBoxTrigger />
    </FieldGroup>
  );
}

export function ComboBoxTrigger() {
  return (
    <Button size="icon-sm" variant="ghost" className="mr-1">
      <ChevronDownIcon />
    </Button>
  );
}

export function ComboBoxClearButton({
  onPress,
}: {
  onPress?: ButtonProps["onPress"];
}) {
  const state = React.useContext(ComboBoxStateContext);

  return (
    <Button
      className={
        state?.inputValue
          ? "visible focus-visible:-outline-offset-2"
          : "invisible"
      }
      slot={null}
      size="icon-sm"
      variant="ghost"
      excludeFromTabOrder
      onPress={(e) => {
        state?.setSelectedKey(null);
        state?.setInputValue("");
        onPress?.(e);
      }}
    >
      <XIcon aria-label="Clear" />
    </Button>
  );
}

export const ComboBoxList = SelectList;

export const ComboBoxSection = SelectSection;

export const ComboBoxItem = SelectItem;
